import Annotation from "./annotation";
import { setLineStyle } from "../canvasUtils";

export default class OtherLine extends Annotation {
  constructor(){
    super();

    this.index = 0;
    this.count = 2;
    this.color = "magenta";

    this.canvasSize = null;
    this.isFlipped270 = false;
  }

  draw(ctx) {
    if(!this.canvasSize) return;
    
    let w = this.canvasSize.w;
    let h = this.canvasSize.h;

    setLineStyle(ctx, this);
    ctx.beginPath();
    let offset = this.count > 1 ? this.index / (this.count - 1) : 0.5;
    let x = 0;
    if (this.isFlipped270) {
      x = h * offset;
      ctx.moveTo(x, 0);
      ctx.lineTo(x, h);
    }
    else {
      x = w * offset;
      ctx.moveTo(x, 0);
      ctx.lineTo(x, h);
    }
    ctx.closePath();
    ctx.stroke();
  }
}